<template>
  <div>
    <div class="manage-info wallet-page">
      <div class="manage-name">账户余额</div>
      <div class="manage-balance">
        <a>¥</a
        ><span class="manage-balance-value">{{ walletMoney }}</span>
        <!-- <span class="wallet-charge">充值</span> -->
        <span class="charge-btn" @click="dialogVisible = true">申请充值</span>
      </div>
    </div>
    <div class="manage-date-select">

      <label style="margin-left: 15px">订单号</label>
      <span>
        <el-input
          v-model="orderSn"
          placeholder="请输入订单号"
          style="width: 200px"
        ></el-input>
      </span>
      <label style="margin-left: 15px">描述</label>
      <span>
        <!-- <el-input v-model="desc" placeholder="请输入描述" style="width: 200px;"></el-input> -->
        <!-- <el-select
          v-model="desc"
          filterable
          placeholder="请选择描述"
          style="width: 200px"
        >
          <el-option
            v-for="item in optionList.desc"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-select v-model="status" filterable placeholder="请选择描述" style="width: 200px;">
          <el-option
            v-for="item in optionList.status"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </span>

      <label style="margin-left: 15px">充值申请ID</label>
      <span>
        <el-input
          v-model="applicationId"
          placeholder="请输入充值申请ID"
          style="width: 200px"
        ></el-input>
      </span>
      <div style="margin-top: 10px;"></div>
      <label>流水查询时间</label>
      <span>
        <el-date-picker
          style="width: 400px"
          class="elpic"
          v-model="timeRage"
          time-arrow-control
          unlink-panels
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </span>
      <div style="margin: 15px 0">
        <span
          class="shelves-filter-btn-default shelves-filter mar-left-10"
          @click="timeInit"
          >查询</span
        >
        <el-button
          :loading="loading"
          class="shelves-filter-btn-default shelves-dc ex-btn"
          @click="excelinit"
          >导出流水</el-button
        >
      </div>
    </div>
    <div style="margin-top: 60px">
      <el-table
        :data="tableData"
        border
        empty-text
        style="width: 100%; text-align: center"
      >
        <el-table-column prop="orderSn" label="订单号" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="时间"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column label="金额" width="120" align="center">
          <template slot-scope="scope"
            ><!--当数据改变时修改样式-->
            <div :class="{ typered: scope.row.type == '+' }">
              {{ scope.row.money }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收支类型" width="120" align="center">
          <template slot-scope="scope"
            ><!--当数据改变时修改样式-->
            <div :class="{ typered: scope.row.type == '+' }">
              {{ scope.row.type }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="描述" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.comment }}
              <!-- <template v-if="scope.row.status == 8">
                （申请ID：{{scope.row.id}}）
                </template> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="描述" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
        <!--<el-table-column
		      label="可用余额"
		      width="120">
		      <template slot-scope="scope">
		      		<div>¥{{scope.row.surplusMoney/100}}</div>
		      </template>
		    </el-table-column>-->
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :total="total"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog title="余额充值申请" :visible.sync="dialogVisible" width="800px">
      <el-form
        :model="formDatas"
        :rules="formRules"
        ref="formDatas"
        size="small"
      >
        <el-form-item label="充值金额：" prop="money" label-width="120px">
          <el-input
            style="width: 300px"
            type="number"
            v-model="formDatas.money"
            auto-complete="off"
            @mousewheel.native.prevent
          ></el-input
          >&nbsp;元
        </el-form-item>
        <el-form-item label="凭证：" prop="imgPath" label-width="120px">
          <el-upload
            class="upload-demo"
            :class="{ disabled: uploadLogodis }"
            accept="image/png, image/gif, image/jpg, image/jpeg"
            name="photo"
            :file-list="formDatas.imgPath"
            :action="upLoad.actionUrl"
            :headers="upLoad.headers"
            :data="upLoad.upLoadData"
            :auto-upload="false"
            :before-upload="handleChangeUpload"
            :on-success="handleUploadSuccess"
            :on-change="handleChange"
            :on-remove="handleRemove"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-row style="margin-bottom: 10px">
            <div style="font-size: 12px; color: rgb(174, 174, 174)">
              上传清晰完整的转账凭证图片
            </div>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer charge-dialog-btn">
        <el-button
          type="primary"
          @click="rechargeFn"
          style="background-color: #ffa726; border-color: #ffa726"
          >提交申请</el-button
        >
        <el-button
          @click="dialogVisible = false"
          style="border-color: #ffa726; color: #ffa726"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
    title="导出提示"
    :visible.sync="dialogVisibleExport"
    width="600px"
    :show-close="false">
    <span>导出任务正在生成，请前往【下载列表】中下载您已导出的信息</span>
    <span slot="footer" class="dialog-footer">
      <el-button style="background-color: #ffa726;border-color: #ffa726;" type="primary" @click="dialogVisibleExport = false" >好的，我知道了</el-button>
    </span>
  </el-dialog>
  </div>
</template>
<script>
import store from "../store/index.js";
import axios from "axios";
import {
  queryAppJournalMall,
  exportAppJournalMall,
  insertAppChangeApply,
  upload
} from "../config/interface.js";
import { toast } from "../util/tool.js";
import { baseURL, fetch } from "../config/fetch.js";

export default {
  data() {
    const checkPrice = (rule, value, callback) => {
      value = value + "";
      const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
      if (!value) {
        return callback(new Error("必填"));
      } else if (reg.test(value)) {
        callback();
      } else {
        return callback(
          new Error("只能输入大于0的数字，小数点后最多只能保留两位")
        );
      }
    };
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value7: "",
      userId: store.state.userId,
      walletMoney: "",
      endTime: "", //结束时间
      startTime: "",
      tableData: [],
      pageSize: 10,
      pageNum: 0,
      total: 0,
      loading: false,
      orderSn: null,
      desc: null,
      dialogVisible: false,
      formRules: {
        money: [{ required: true, validator: checkPrice, trigger: "blur" }],
        imgPath: [{ required: true, message: "请上传图片", trigger: "blur" }],
      },
      formDatas: {
        money: null,
        imgPath: [],
        hotPic: "",
      },
      upLoad: {
        actionUrl: baseURL + upload,
        headers: {
          userToken: this.$store.state.token,
        },
        upLoadData: {
          catalog: 0,
          userId: store.state.userId,
        },
      },
      uploadLogodis: false, //移除logol
      optionList: {
        desc: [
          { name: "全部", id: null },
          { name: "充值", id: "充值" },
          { name: "授信", id: "授信" },
          { name: "异业结算费", id: "异业结算费" },
          { name: "售后退款返还", id: "售后退款返还" },
        ],
        status: [
            {
              id: null,
              name: '全部',
            },
            {
              id: 100,
              name: '充值',
            },
            {
              id: 200,
              name: '授信',
            },
            {
              id: 300,
              name: '售后返还',
            },
            {
              id: 400,
              name: '补贴',
            },
            {
              id: 1100,
              name: '授信回收',
            },
            {
              id: 1200,
              name: '提现'
            },
            {
              id: 1300,
              name: '下单扣款'
            }
            ,
            {
              id: 1400,
              name: '罚款'
            }
          ]
      },
      applicationId: null,
      rechargeQuery: true,
      status: null,
      dialogVisibleExport: false,
      timeRage: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    rechargeFn() {
      this.$refs["formDatas"].validate((valid) => {
        if (valid) {
          if(this.rechargeQuery == true){
            this.rechargeQuery = false;
            var params = {
              //请求数据
              appChargeApply: {
                money: this.subNumber(this.formDatas.money,100),
                pictureUrl: this.formDatas.hotPic,
              },
              userId: this.userId,
              appId: this.$store.state.appId,
            };
            var url = insertAppChangeApply;
            fetch(url, params)
              .then((res) => {
                if (res.code == 10000) {
                  toast("提交申请成功", 1, false);
                  this.formDatas.money = null,
                  this.formDatas.imgPath = [];
                  this.formDatas.hotPic = "";
                  this.dialogVisible = false;
                  this.rechargeQuery = true;
                }
              })
              .catch(function (err) {});
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    subNumber(arg1, arg2) {
      //	return (arg1 * 1000) * (arg2 * 1000) / 1000000; //防止丢失精度
      if (arg1 != undefined && arg2 != undefined) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try { m += s1.split(".")[1].length } catch (e) { }
        try { m += s2.split(".")[1].length } catch (e) { }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
      var Img = new Image(),
        dataURL = "",
        type = file.raw.type,
        self = this;
      Img.src = file.url;
      var suffix = type.substring(6);
      var file1 = file;
      Img.onload = function() {
        var canvas = document.createElement("canvas"),
          width = Img.width,
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
        dataURL = canvas.toDataURL(type, 0.3);
        var handleUrl = dataURL.split(",")[1];
        var data = {
          imgBase: handleUrl,
          suffix: suffix,
          userId: self.userId,
          url: 'file/user/',
        };
        var url = upload;

        fetch(url, data).then(res => {
          if (res.code === 10000) {
            let icoPath = res.data;
            self.formDatas.imgPath.push({ url: res.data });
            self.formDatas.hotPic = res.data;
            self.uploadLogodis = fileList.length === 1 ? true : false;
          } else {
            if (res.code == 20100) {
              router.replace({
                path: "/",
              });
            } else {
              bs.toast(res.message, "error", false);
            }
          }
        });
      };
    },
    //上传图片之前对图片大小进行校验
    handleChangeUpload(file) {
      let _this = this;
      const isSize = new Promise(function (resolve, reject) {
        let width = 750;
        let height = 376;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          // let valid = img.width <= width && img.height <= height;
          // valid ? resolve() : reject();
          resolve();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          //  bs.toast('请按标准上传图片','warning',false)
          return Promise.reject();
        }
      );
      return isSize;
    },
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 10000) {
        let icoPath = response.data;
        this.formDatas.imgPath.push({ url: response.data });
        this.formDatas.hotPic = response.data;
        this.uploadLogodis = fileList.length === 1 ? true : false;
      } else {
        if (response.code == 20100) {
          router.replace({
            path: "/",
          });
        } else {
          bs.toast(response.message, "error", false);
        }
      }
    },
    handleRemove(file, fileList) {
      this.uploadLogodis = fileList.length === 1 ? true : false;
      this.formDatas.imgPath = [];
      this.formDatas.hotPic = "";
    },
    init(){
      // this.init1();
      this.init2();
    },
    init2() {



      var data = {
          startTime: this.timeRage?this.timeRage[0]:null,
          endTime: this.timeRage? this.timeRage[1]:null,
        userId: this.userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        orderSn: this.orderSn,
        applyJournalId: this.applicationId,
        appId: this.$store.state.appId,
        status: this.status,
      };
      var url = queryAppJournalMall;
      fetch(url, data).then((res) => {
        let list = res.data.result;
        this.walletMoney = res.data.money/100;
        list.forEach(item => {
          item.money = item.money/100;
          item.createTime = item.createTime.toString().substr(0,19);
          // item.updateTime = item.updateTime.toString().substr(0,19);
        })
        this.total = res.data.count;
        this.tableData = list;
      });
    },
    init1() {

      var data = {
        startTime: this.timeRage?this.timeRage[0]:null,
          endTime: this.timeRage? this.timeRage[1]:null,
        userId: this.userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        orderSn: this.orderSn,
        desc: this.desc,
        id: this.applicationId,
        bodyId: this.$store.state.bodyId,
      };
      var url = walletInfo;
      fetch(url, data).then((res) => {
        // debugger
        // this.walletMoney = res.data.money;

      });
    },
    excelinit() {

      if(!this.timeRage || this.timeRage.length <= 0){
          var str = "请先选择时间";
          toast(str, 3, false);
          return false;
        }
      // this.dialogVisibleExport = true;



      //点击导出流水
      this.loading = true;
      var params = {
        //请求数据
        startTime: this.timeRage?this.timeRage[0]:null,
          endTime: this.timeRage? this.timeRage[1]:null,
        userId: this.userId,

        orderSn: this.orderSn,
        applyJournalId: this.applicationId,
        appId: this.$store.state.appId,
        status: this.status,
      };
      var url = exportAppJournalMall;
      axios.defaults.timeout = 30000;
      let responseType = "arraybuffer"; //返回数据类型
      fetch(url, params, responseType)
        .then((res) => {
          if(res.data){
            let fileName = res.headers["content-disposition"].substring(
              res.headers["content-disposition"].indexOf("=") + 1
            );
            fileDownload(res.data, fileName);
            toast('导出成功', 1, false);
            console.log("导出成功");
          }
          this.loading = false;
        })
        .catch(function (err) {
          console.log("导出失败");
          this.loading = false;
        });
    },
    timeInit() {
      this.total = 0;
      this.init();
    },
    setTime(val) {
      this.startTime = val.substring(0, 19);
      this.endTime = val.substring(22, 42);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.init();
    },
    // download() {
    //   if (this.startTime == "" || this.endTime == "") {
    //     var str = "请先选择时间";
    //     toast(str, 2, false);
    //     return;
    //   }
    //   const data = {
    //     endTime: this.endTime,
    //     startTime: this.startTime,
    //     userId: this.userId,
    //   };

    //   const url = walletDownload;

    //   fetch(url, data).then((res) => {
    //     console.log(res);
    //   });
    // },
  },
};
</script>
<style scoped>
.typered {
  color: red;
}
.el-button.ex-btn {
  margin-right: 14px;
  margin-left: 0;
  padding: 0;
  border-radius: 0;
}
.elpic {
  width: 210px;
}
.charge-btn {
  border: 1px solid #409eff;
  color: #409eff;
  cursor: pointer;
  top: -5px;
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 14px;
}
.charge-dialog-btn {
  text-align: center;
  display: block;
}
.charge-dialog-btn .el-button {
  padding: 10px 20px;
  border-radius: 4px;
}
</style>
<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Wallet.vue?6ef2bfe6